<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>博世商用车增值计划（CV Plan）</span></h1>
    <p>
      博世商用车增值计划（CV Plan）是博世商用车渠道的维修站销售概念，分为博世商用车配件质选（Plan CV）以及博世商用车配件精选（CSS）。博世商用车增值计划是为了帮助商用车修理厂建立系统性的柴油喷射、后处理、天然气故障诊断及更换能力，以品牌为基石，通过服务授权、数字化运营和流量扶持，让博世商用车修理厂以服务车主为中心，不愁生意，持续盈利。
    </p>
  </div>
  <!-- <app-scroll-spy-nav [sections]="[
  { id: 'bdx-1', label: '档案和维修' },
  { id: 'bdx-2', label: '博世柴油系统服务' },
  { id: 'bdx-3', label: '提供的服务' }]">
  </app-scroll-spy-nav> -->
  <section id="bdx-1" class="equipment-content">
    <div class="business-content">
      <div class="business-left">
        <h1>CSS博世商用车配件精选</h1>
        <img src="assets/official-website/CV.jpg" class="w-full" alt="CV">
      </div>
      <div class="business-right">
        <h1>Plan CV 博世商用车配件质选</h1>
        <img src="assets/official-website/CV2.jpg" class="w-full" alt="CV2">
      </div>
    </div>
  </section>
  <!-- <section id="bdx-2" class="equipment-content">
    <div class="business-content">
      <div class="business-right mx:hidden">
        <img src="assets/official-website/CV2.jpg" class="w-full" alt="CV2">
      </div>
      <div class="business-left">
        <h1>CV Plan博世商用车配件质选</h1>
      </div>
      <div class="business-right sm:hidden">
        <img src="assets/official-website/CV2.jpg" class="w-full" alt="CV2">
      </div>
    </div>
    <div class="business-content">
      <div class="business-left">
        <img src="assets/official-website/CV3.png" class="w-full" alt="CV3">
      </div>
      <div class="business-right">
        <h1>价值主张</h1>
        <ul class="detail-list">
          <li>
            博世商用车修理厂以服务车主为中心，不愁生意，持续盈利。
          </li>
        </ul>
      </div>
    </div>
  </section> -->
</div>